import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-10/task-02";

const task: Slide = {
  titleHtml: `What is a suitable reverberation time (RT) range for a speech classroom of 90 m<sup>2</sup> floor surface and 3 m height? `,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
